import { get, set } from 'lodash'

export const StaticObjectFormat = {
  getValue(model) {
    return model
  },
  setValue(model, key, value) {
    model = Object.assign({}, model, value)
    return model
  },
}
export const StaticFormat = {
  getValue(model, key) {
    return get(model, key)
  },
  setValue(model, key, value) {
    return set(model, key, value)
  },
}

export const StaticMetaFormat = {
  getValue(model, key) {
    return get(model, 'meta.' + key)
  },
  setValue(model, key, value) {
    return set(model, 'meta.' + key, value)
  },
}
export const StaticLinkFormat = {
  getValue(model, key) {
    return get(model, key)
  },
  setValue(model, key, value, type_field) {
    if (type_field.field.items && type_field.field.items.length) {
      let item = type_field.field.items.find((x) => x.value == value)
      if (item && item.code) {
        set(model, 'ma' + key, item.code)
      }
    }

    return set(model, key, value)
  },
}
